mutation SetEventYouTubeSource($eventId: ID!, $attached: Boolean!) {
  result: StreamToolsSetEventYouTubeSource(eventId: $eventId, attached: $attached) {
    eventId
    youtubeSourceAttached
  }
}
